import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import locationActions from "../../../../_actions/locationActions";

class EditLocationModal extends Component {
  state = {
    formData: {
      projectId: 0,
      name: "",
      locationTypeId: null,
      selectedLocationType: null,
      bridgeNo: "",
      includeCtyRtePm: false,
      ctyRtePm: "",
      includeStation: false,
      useFixedStation: false,
      useStationRange: false,
      alignmentFixed: "",
      alignmentRange: "",
      alignment: "", // Property provided for mapping to LocationDto
      fixedStation: "",
      stationFrom: "",
      stationTo: "",
      description: "",
    },
    formErrors: {
      name: null,
      locationType: null,
      bridgeNo: null,
      ctyRtePm: null,
      alignmentFixed: null,
      alignmentRange: null,
      fixedStation: null,
      stationFrom: null,
      stationTo: null,
      description: null,
    },
    touched: {
      name: false,
      locationType: false,
      bridgeNo: false,
      ctyRtePm: false,
      alignmentFixed: false,
      alignmentRange: false,
      fixedStation: false,
      stationFrom: false,
      stationTo: false,
      description: false,
    },
    locationTypeOptions: [],
  };

  componentDidMount() {
    const { isNewLocation, location } = this.props;
    const formData = { ...this.state.formData };

    const locationTypeOptions = this.buildLocationTypeOptions();

    if (!isNewLocation && location) {
      const selectedLocationType = locationTypeOptions.find(
        (lto) => lto.value === location.locationTypeId
      );

      formData.locationId = location.locationId;
      formData.projectId = location.projectId;
      formData.name = location.name;
      formData.description = location.description;
      formData.locationTypeId = location.locationTypeId;
      formData.selectedLocationType = selectedLocationType;
      formData.bridgeNo = location.bridgeNo;

      if (location.ctyRtePm) {
        formData.includeCtyRtePm = true;
        formData.ctyRtePm = location.ctyRtePm;
      }
      if (location.alignment) {
        formData.includeStation = true;
        if (location.fixedStation) {
          formData.useFixedStation = true;
          formData.useStationRange = false;
          formData.alignmentFixed = location.alignment;
          formData.fixedStation = location.fixedStation;
        } else if (location.stationFrom && location.stationTo) {
          formData.useFixedStation = false;
          formData.useStationRange = true;
          formData.alignmentRange = location.alignment;
          formData.stationFrom = location.stationFrom;
          formData.stationTo = location.stationTo;
        }
      }
    }

    this.setState({ formData, locationTypeOptions });
  }

  componentDidUpdate(prevProps, prevState) {
    const { locationTypeList } = this.props;
    if (locationTypeList && prevProps.locationTypeList !== locationTypeList) {
      const locationTypeOptions = this.buildLocationTypeOptions();
      this.setState({ locationTypeOptions });
    }
  }

  buildLocationTypeOptions = () =>
    (this.props.locationTypeList || [])
      .filter((lt) => lt.description !== "General")
      .map((lt) => ({ value: lt.locationTypeId, label: lt.description }));

  handleChange = (e) => {
    const formData = { ...this.state.formData };
    formData[e.target.name] = e.target.value;
    this.setState({ formData });
  };

  handleBlur = (e) => {
    this.validateForm(e.target.name);
    this.setState({
      touched: { ...this.state.touched, [e.target.name]: true },
    });
  };

  handleBlur_locationType = (fieldName) => () => {
    this.validateForm(fieldName);
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });
  };

  handleChange_locationType = (selectedLocationOption) => {
    const formData = { ...this.state.formData };
    formData.selectedLocationType = selectedLocationOption;
    formData.locationTypeId = selectedLocationOption.value;
    this.setState({ formData }, () => this.validateForm("locationType"));
  };

  handleLocationDetailsToInclude = (e) => {
    const formData = { ...this.state.formData };
    const formErrors = { ...this.state.formErrors };
    formData[e.target.name] = e.target.checked;

    // Clear existing error when being unchecked
    if (e.target.checked === false) {
      if (e.target.name === "includeCtyRtePm") formErrors.ctyRtePm = null;
      if (e.target.name === "includeStation") {
        formErrors.alignmentFixed = null;
        formErrors.alignmentRange = null;
      }
    }
    this.setState({ formData, formErrors });
  };

  handleStationInputMethodToggle = (e) => {
    const formData = { ...this.state.formData };
    const formErrors = { ...this.state.formErrors };

    if (e.target.id === "useFixedStation") {
      formData.useFixedStation = true;
      formData.useStationRange = false;
    } else if (e.target.id === "useStationRange") {
      formData.useFixedStation = false;
      formData.useStationRange = true;
    }

    // Clear any existing errors when changing station input method
    if (formData.useFixedStation) formErrors.alignmentRange = null;
    if (formData.useStationRange) formErrors.alignmentFixed = null;

    this.setState({ formData, formErrors });
  };

  validateForm = (fieldName) => {
    const { formData } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "name":
        if (formData.name === "") formErrors.name = "Location name is required";
        else formErrors.name = null;
        break;
      case "locationType":
        if (formData.selectedLocationType == null)
          formErrors.locationType = "Location type is required";
        else formErrors.locationType = null;
        break;
      case "ctyRtePm":
        if (formData.includeCtyRtePm && formData.ctyRtePm === "")
          formErrors.ctyRtePm = "Required";
        else formErrors.ctyRtePm = null;
        break;
      case "alignmentFixed":
        // Ensure at least the alignment is provided.
        if (formData.useFixedStation === true)
          if (formData.alignmentFixed === "") formErrors.alignmentFixed = "Required";
          else formErrors.alignmentFixed = null;
        break;
      case "alignmentRange":
        if (formData.useStationRange === true)
          if (formData.alignmentRange === "") formErrors.alignmentRange = "Required";
          else formErrors.alignmentRange = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const { name, locationType, ctyRtePm, alignmentFixed, alignmentRange } =
      this.state.formErrors;
    const { formData } = this.state;
    if (
      name ||
      locationType ||
      ctyRtePm ||
      alignmentFixed ||
      alignmentRange ||
      !formData.name ||
      !formData.selectedLocationType
    )
      return true;
    else return false;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { dispatch, projectId, locationId, toggleModal, isNewLocation } = this.props;
    const { formData } = this.state;
    if (!this.formIsIncomplete()) {
      // If Station check is clear, blank out all station-related fields
      if (!formData.includeStation) {
        formData.alignment = "";
        formData.fixedStation = "";
        formData.stationFrom = "";
        formData.stationTo = "";
      }

      // formData divides alignment field into 'fixed' and 'range'
      // Combine them into 'alignment' in order to match DTO signature
      if (formData.includeStation && formData.useFixedStation) {
        formData.alignment = formData.alignmentFixed;
        formData.stationFrom = "";
        formData.stationTo = "";
      }
      if (formData.includeStation && formData.useStationRange) {
        formData.alignment = formData.alignmentRange;
        formData.fixedStation = "";
      }

      // If Line is provided for either fixed or range, but no stations are provided,
      // do not save the alignment.
      // TODO: Warn user that stations are missing
      if (
        formData.includeStation &&
        (!formData.alignmentFixed || !formData.alignmentRange)
      )
        formData.alignment = "";

      if (!formData.includeCtyRtePm) formData.ctyRtePm = "";
      formData.projectId = projectId;
      if (isNewLocation) await dispatch(locationActions.add(formData));
      else {
        await dispatch(locationActions.update(formData));
        dispatch(locationActions.getDetails(locationId, projectId));
      }
      dispatch(locationActions.getAll(projectId));
      toggleModal();
    }
  };

  render() {
    const { showModal, toggleModal, isNewLocation } = this.props;
    const { formData, formErrors, locationTypeOptions } = this.state;
    const closeBtn = (
      <button className="close" onClick={toggleModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );

    return (
      <Modal
        isOpen={showModal}
        toggle={toggleModal}
        className={this.props.className}
        size={"lg"}
        fade={false}
      >
        <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
          {isNewLocation ? (
            <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
          ) : (
            <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
          )}
          {isNewLocation ? "Add Location" : "Edit Location"}
        </ModalHeader>
        <ModalBody>
          <form id="addNewLocationForm" onSubmit={this.handleSubmit} autoComplete={"off"}>
            <div className="form-row form-group mb-2">
              <label htmlFor="name" className="col-sm-3 col-form-label">
                <b>Location Name:</b>*
              </label>
              <div className="col-sm-6">
                <input
                  type="text"
                  name="name"
                  id="name"
                  className="form-control"
                  maxLength="50"
                  value={formData.name}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                />
                {formErrors.name && (
                  <span className="error-small">
                    <small>{formErrors.name}</small>
                  </span>
                )}
              </div>
            </div>
            <div className="form-row form-group mb-2">
              <label htmlFor="locationType" className="col-sm-3 col-form-label">
                <b>Location Type:</b>*
              </label>
              <div className="col-sm-6">
                <Select
                  name="locationType"
                  id="locationType"
                  value={formData.selectedLocationType}
                  options={locationTypeOptions}
                  onChange={this.handleChange_locationType}
                  onBlur={this.handleBlur_locationType("locationType")}
                />
                {formErrors.locationType && (
                  <span className="error-small">
                    <small>{formErrors.locationType}</small>
                  </span>
                )}
              </div>
            </div>
            <div className="form-row form-group mb-2">
              <label htmlFor="description" className="col-sm-3 col-form-label">
                Description:
              </label>
              <div className="col-sm-6">
                <input
                  name="description"
                  id="description"
                  className="form-control"
                  value={formData.description}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  maxLength="1000"
                />
              </div>
            </div>
            <div className="card my-2">
              <div className="card-body p-3">
                <h5 className="text-muted">Location Details</h5>
                <div className="form-row form-group mb-2">
                  <label htmlFor="bridgeNo" className="col-sm-3 col-form-label">
                    Bridge No:
                  </label>
                  <div className="col-sm-4">
                    <input
                      type="text"
                      name="bridgeNo"
                      id="bridgeNo"
                      className="form-control"
                      maxLength="10"
                      value={formData.bridgeNo}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                    />
                  </div>
                </div>
                <div className="form-row form-group mb-2">
                  <div className="col-sm-3 my-auto">
                    <div className="custom-control-inline custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name="includeCtyRtePm"
                        id="includeCtyRtePm"
                        className="custom-control-input my-auto"
                        checked={formData.includeCtyRtePm}
                        onChange={this.handleLocationDetailsToInclude}
                      />
                      <label
                        htmlFor="includeCtyRtePm"
                        className="custom-control-label my-auto"
                      >
                        Co-Rte-PM:
                      </label>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <input
                      type="text"
                      name="ctyRtePm"
                      id="ctyRtePm"
                      className="form-control my-auto"
                      maxLength="30"
                      value={formData.ctyRtePm}
                      onChange={this.handleChange}
                      disabled={formData.includeCtyRtePm === false}
                      onBlur={this.handleBlur}
                    />
                    {formErrors.ctyRtePm && (
                      <span className="error-small">
                        <small>{formErrors.ctyRtePm}</small>
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-row form-group mb-2">
                  <div className="col-sm-2">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name="includeStation"
                        id="includeStation"
                        className="custom-control-input my-auto"
                        checked={formData.includeStation}
                        onChange={this.handleLocationDetailsToInclude}
                      />
                      <label
                        htmlFor="includeStation"
                        className="custom-control-label my-auto"
                      >
                        Station:
                      </label>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-body">
                    <div className="form-row form-group mb-2 ml-6">
                      <div className="col-sm-2 my-auto">
                        <div className="custom-control-inline custom-control custom-radio">
                          <input
                            type="radio"
                            name="useFixedStation"
                            id="useFixedStation"
                            className="custom-control-input my-auto"
                            checked={formData.useFixedStation}
                            onChange={this.handleStationInputMethodToggle}
                            onBlur={this.handleBlur}
                            disabled={!formData.includeStation}
                          />
                          <label
                            htmlFor="useFixedStation"
                            className="custom-control-label my-auto"
                          >
                            Fixed:
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-8 form-inline">
                        <label
                          htmlFor="alignmentFixed"
                          className="col-form-label mr-2 my-auto"
                        >
                          Line
                        </label>
                        <input
                          type="text"
                          name="alignmentFixed"
                          id="alignmentFixed"
                          className="col-sm-2 form-control mr-2 my-auto"
                          maxLength="20"
                          value={formData.alignmentFixed}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                          disabled={!formData.includeStation || !formData.useFixedStation}
                        />
                        {formErrors.alignmentFixed && (
                          <span className="error-small">
                            <small>{formErrors.alignmentFixed}</small>
                          </span>
                        )}
                        <label
                          htmlFor="fixedStation"
                          className="col-form-label mr-2 my-auto"
                        >
                          @ Sta.
                        </label>
                        <input
                          type="text"
                          name="fixedStation"
                          id="fixedStation"
                          className="col-sm-4 form-control my-auto"
                          maxLength="20"
                          value={formData.fixedStation}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                          disabled={!formData.includeStation || !formData.useFixedStation}
                        />
                      </div>
                    </div>
                    <div className="form-row form-group mb-2 ml-6">
                      <div className="col-sm-2 my-auto">
                        <div className="custom-control-inline custom-control custom-radio">
                          <input
                            type="radio"
                            name="useStationRange"
                            id="useStationRange"
                            className="custom-control-input my-auto"
                            checked={formData.useStationRange}
                            onChange={this.handleStationInputMethodToggle}
                            disabled={!formData.includeStation}
                          />
                          <label
                            htmlFor="useStationRange"
                            className="custom-control-label mr-3 my-auto"
                          >
                            Range:
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-8 form-inline">
                        <label
                          htmlFor="alignmentRange"
                          className="col-form-label mr-2 my-auto"
                        >
                          Line
                        </label>
                        <input
                          type="text"
                          name="alignmentRange"
                          id="alignmentRange"
                          className="col-sm-2 form-control mr-2 my-auto"
                          maxLength="20"
                          value={formData.alignmentRange}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                          disabled={!formData.includeStation || !formData.useStationRange}
                        />
                        {formErrors.alignmentRange && (
                          <span className="error-small">
                            <small>{formErrors.alignmentRange}</small>
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="form-row form-group mb-0 ml-6">
                      <div className="col-sm-2 my-auto" />
                      <div className="col-sm-8 form-inline">
                        <label htmlFor="stationFrom" className="col-form-label mr-2">
                          From Sta.
                        </label>
                        <input
                          type="text"
                          name="stationFrom"
                          id="stationFrom"
                          className="col-sm-4 form-control mr-2"
                          maxLength="20"
                          value={formData.stationFrom}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                          disabled={!formData.includeStation || !formData.useStationRange}
                        />
                        <label htmlFor="stationTo" className="col-form-label mr-2">
                          To
                        </label>
                        <input
                          type="text"
                          name="stationTo"
                          id="stationTo"
                          className="col-sm-4 form-control"
                          maxLength="20"
                          value={formData.stationTo}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                          disabled={!formData.includeStation || !formData.useStationRange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group mb-0">
            <input
              className="btn btn-primary"
              name="addNewLocationButton"
              type="submit"
              form="addNewLocationForm"
              onClick={this.handleSubmit}
              value={isNewLocation ? "Add" : "Save"}
              disabled={this.formIsIncomplete()}
            />{" "}
            <button
              className="btn btn-secondary ml-2"
              color="secondary"
              onClick={toggleModal}
            >
              Cancel
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  locationTypeList: state.feederLists.locationTypeList || null,
  location: state.locations.openLocationDetails[ownProps.projectId]
    ? state.locations.openLocationDetails[ownProps.projectId][ownProps.locationId] || null
    : null,
  fetching: state.locations.fetching,
});

export default connect(mapStateToProps)(EditLocationModal);
